import {styled} from '@innowise-group/ui-kit';
import {Calendar} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 0.375rem;
`;

export const Timeline = styled(Calendar)`
  height: 100%;

  .rbc-time-header {
    display: none;
  }

  .rbc-time-view {
    border: none;
  }

  .rbc-time-content {
    border: none;
    padding-top: 0.3125rem;

    &::-webkit-scrollbar {
      height: 0.625rem;
      width: 0.625rem;
    }

    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-corner {
      background: ${({theme}) => theme.palette.generalAlt.scrollbar.track};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0.625rem;
      background: ${({theme}) => theme.palette.generalAlt.scrollbar.thumb};
      border: 0.125rem solid ${({theme}) => theme.palette.generalAlt.scrollbar.track};
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({theme}) => theme.palette.general.lightGrey[80]};
    }
  }

  .rbc-time-gutter {
    & > .rbc-timeslot-group {
      border-bottom: none;
    }
    & > .rbc-timeslot-group:last-child {
      position: relative;
    }
    & > .rbc-timeslot-group:last-child::after {
      content: '24:00';
      position: absolute;
      bottom: 0;
      transform: translateY(50%);
      left: 0.3125rem;
      z-index: 100;
      color: ${({theme}) => theme.palette.generalAlt.font.primary};
      font-family: Manrope;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.57;
      letter-spacing: 0.0156rem;

      @media (max-width: 480px) {
        font-size: 0.8rem;
      }
    }
  }

  .rbc-time-content > * + * > * {
    border-left: none;
  }

  .rbc-today,
  .rbc-day-slot {
    background-color: transparent;
    padding: 0 0.625rem 0 3.75rem;

    @media (max-width: 480px) {
      padding: 0 0.625rem 0 2.8125rem;
    }
  }

  .rbc-day-slot {
    & .rbc-events-container {
      width: calc(100% - 4.375rem);
      left: 3.75rem;

      @media (max-width: 480px) {
        width: calc(100% - 3.4375rem);
        left: 2.8125rem;
      }
    }
    .rbc-slot-selection {
      width: calc(100% - 4.375rem);
      border-radius: 0.5rem;
      background-color: ${({theme}) => theme.palette.specials.meetings.backSecondary};

      @media (max-width: 480px) {
        width: calc(100% - 3.4375rem);
      }
    }

    & .rbc-time-slot:nth-child(even) {
      border-top: none;
    }

    & .rbc-time-slot:nth-child(odd) {
      border-top: ${({theme}) => `0.0625rem solid ${theme.palette.specials.meetings.borderThin}`};
    }

    & .rbc-time-slot:nth-child(3n) {
      border-top: ${({theme}) => `0.0625rem solid ${theme.palette.specials.meetings.borderThin}`};
    }

    & > .rbc-timeslot-group {
      border-bottom: ${({theme}) => `0.0625rem solid ${theme.palette.specials.meetings.borderThick}`};
    }

    & > .rbc-timeslot-group:first-child {
      border-top: ${({theme}) => `0.0625rem solid ${theme.palette.specials.meetings.borderThick}`};
    }

    & .rbc-event-content,
    & .rbc-event-content > div {
      display: none;
    }
  }

  .rbc-timeslot-group {
    min-height: 4rem;
  }

  .rbc-time-gutter > .rbc-timeslot-group > .rbc-time-slot {
    position: relative;
    & .rbc-label {
      position: absolute;
      top: 0;
      transform: translateY(-50%);
      left: 0;
      z-index: 100;
      color: ${({theme}) => theme.palette.generalAlt.font.primary};
      font-family: Manrope;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.57;
      letter-spacing: 0.0156rem;

      @media (max-width: 480px) {
        font-size: 0.8rem;
      }
    }
  }

  .rbc-current-time-indicator {
    height: 0.125rem;
    left: 3.125rem;
    background-color: ${({theme}) => theme.palette.general.smart};

    &:before {
      content: '';
      width: 0.5625rem;
      height: 0.5625rem;
      background-color: ${({theme}) => theme.palette.general.smart};
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      border-radius: 50%;
    }
    @media (max-width: 480px) {
      left: 2.1875rem;
    }
  }

  .rbc-event,
  .rbc-day-slot .rbc-background-event {
    min-width: 100%;
    min-height: 1rem;
    left: 0 !important;
    border-radius: 0.5rem;
    background: rgba(236, 143, 170, 0.8);
    padding: 0px 0.8rem;
    border: none;
    color: #353535;
    font-family: Manrope;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.33;
    letter-spacing: 0.0156rem;
  }

  .rbc-event {
    display: flex;
    justify-content: center;
    background: ${({theme}) => theme.palette.specials.meetings.backPrimary};
    & > .rbc-addons-dnd-resizable {
      display: flex;
      align-items: center;
    }
  }

  .rbc-event-label {
    font-size: 100%;
    color: ${({theme}) => theme.palette.general.darkGrey[100]};
  }
`;
